import React from "react";

import styles from "./Places.module.scss";


const Places = () => {
  return (
    <div className={styles.layoutWrapper}>
      <h1>Places</h1>
    </div>
  );
};

export default Places;